// extracted by mini-css-extract-plugin
export default {"faqSection":"FAQ_faqSection__S90+4","title":"FAQ_title__iATW7"};